import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import FormCreator from '../../../../../components/forms/FormCreator';
import Buttons from '../../../../../components/ui/button/Buttons';
import { NoOfSeatsFormData } from '../data/NoOfSeatsForm.Data.';
import { FormFieldTypes } from '../../../../../components/forms/libs/data/formFieldType';
import { validationTypes } from '../../../../../components/forms/libs/data/ValidationTypes';
import { useAddEditEventLessonTimeSlotDetailsMutation } from '../../../../../app/services/EventManagement/EventManagementApi';
import ToastService from '../../../../../services/toastService/ToastService';

const NoOfSeats = forwardRef((props, ref) => {
    const noofSeatsRef = useRef();
    const [noOfSeatsForm, setNoOfSeatsForm] = useState(NoOfSeatsFormData);

    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (noofSeatsRef.current) {
                return noofSeatsRef.current.getFormData();
            }
            return null;
        }
    }));

    const updateSessionFields = (sessionCount) => {
        const currentSessionCount = parseInt(noOfSeatsForm.initialState.sessionNumbers, 10) || 0;
        if (sessionCount > currentSessionCount) {
            const fields = NoOfSeatsFormData.section[0].fields;

            // Filter out existing dynamic fields
            const staticFields = fields.filter(
                (field) =>
                    !field.id.startsWith("date_") &&
                    !field.id.startsWith("startAt_") &&
                    !field.id.startsWith("endsAt_")
            );

            // Create new dynamic fields
            const dynamicFields = [];
            for (let i = 1; i <= sessionCount; i++) {
                dynamicFields.push(
                    {
                        id: `date_${i}`,
                        label: `Date`,
                        Field_Name: `Date`,
                        fieldType: FormFieldTypes.DATEPICKER,
                        dataField: `date_${i}`,
                        fieldSetting: {
                            allowSpace: true,
                            placeholder: "Select",
                        },
                        validation: [{ type: validationTypes.REQUIRE }],
                        style: {
                            containerCss: "col-lg-4 col-md-4 validation-left-0",
                        },
                    },
                    {
                        id: `startAt_${i}`,
                        label: `Start At`,
                        Field_Name: `Start At`,
                        fieldType: FormFieldTypes.TIMEPICKER,
                        dataField: `startAt_${i}`,
                        fieldSetting: {
                            allowSpace: true,
                            placeholder: "Select",
                        },
                        validation: [{ type: validationTypes.REQUIRE }],
                        style: {
                            containerCss: "col-lg-4 col-md-4 validation-left-0",
                        },
                    },
                    {
                        id: `endsAt_${i}`,
                        label: `Ends At`,
                        Field_Name: `Ends At`,
                        fieldType: FormFieldTypes.TIMEPICKER,
                        dataField: `endsAt_${i}`,
                        fieldSetting: {
                            allowSpace: true,
                            placeholder: "Select",
                        },
                        validation: [{ type: validationTypes.REQUIRE }],
                        style: {
                            containerCss: "col-lg-4 col-md-4 validation-left-0",
                        },
                    }
                );
            }

            // Combine static and new dynamic fields
            NoOfSeatsFormData.section[0].fields = [...staticFields, ...dynamicFields];
        }
        else {
            return false
        }

    }

    const memoizedHandleFieldChange = (dataFieldName, updateFormData) => {
        if (dataFieldName === "sessionNumbers" && updateFormData?.sessionNumbers > 0) {
            updateSessionFields(updateFormData?.sessionNumbers);
        }
    }
    return (
        <React.Fragment>
            <div className="row">
                <FormCreator
                    config={noOfSeatsForm}
                    ref={noofSeatsRef}
                    key={false}
                    onColumnChange={memoizedHandleFieldChange}
                />
            </div>
            {/* <div className="row mt-5">
                <div className="col-lg-12">
                    <Buttons
                        buttonText="Generate"
                        buttonTypeClassName="theme-btn btn mt-auto"
                        onClick={handleGenerate}
                    />
                </div>
            </div> */}
        </React.Fragment>
    );
});

export default NoOfSeats;
